module.exports = __webpack_public_path__ + "static/media/mp3-player.161292a6.svg";